import {NGPReport} from '../../../shared-utilities/models-old/ngp-reports/ngp-report';
import {FiltersAndTools} from '../../../shared-utilities/models-old/ngp-reports/filters-tools-ngp';
import {HeaderMenuColumnData} from '../../../shared-utilities/models-old/ngp-report-grid/header-menu-data';
import {
  IAdvancedFilterGroup,
} from '../../settings-new/models/general/advanced-filter-group.interface';
import {
  applyAdvancedFilterGroupToData,
} from '../../settings-new/models/general/advanced-filters.utils';

export function getSelectNGPReportsFiltered(
  ngpReports: NGPReport[],
  filtersAndTools: FiltersAndTools,
): NGPReport[] {
  if (!filtersAndTools) {
    return ngpReports || [];
  }
  if (filtersAndTools.showSubmissionPreview) {
    return (ngpReports ?? []).filter((row: NGPReport): boolean => row.isEdited || row.isSelected);
  }
  let copyNGPReports: NGPReport[] = [...(ngpReports ?? [])];

  if (filtersAndTools.isGpDifferenceNegativeOn && !filtersAndTools.isGpDifferencePositiveOn) {
    copyNGPReports = copyNGPReports.filter((row: NGPReport): boolean => Number(row.originalValue['diffGP'].value) < 0);
  } else if (filtersAndTools.isGpDifferencePositiveOn && !filtersAndTools.isGpDifferenceNegativeOn) {
    copyNGPReports = copyNGPReports.filter((row: NGPReport): boolean => Number(row.originalValue['diffGP'].value) >= 0);
  } else if (!filtersAndTools.isGpDifferencePositiveOn && !filtersAndTools.isGpDifferenceNegativeOn) {
    copyNGPReports = [];
  }

  if (
    filtersAndTools.isEditedItemsOn &&
    filtersAndTools.isGpDifferencePositiveOn &&
    filtersAndTools.isGpDifferenceNegativeOn
  ) {
    copyNGPReports = copyNGPReports.filter((row: NGPReport): boolean => row.isEdited);
  }

  return copyNGPReports;
}


export function selectGetSelectNGPReportsFiltered(
  ngpReports: NGPReport[],
  storeHeaderMenuData: Record<string, HeaderMenuColumnData>,
): NGPReport[] {
  let found = '';
  let sortType = '';

  Object.keys(storeHeaderMenuData ?? {}).forEach((key: string): void => {
    if (key === 'depName' || key === 'subDepName') {
      return;
    }
    if (storeHeaderMenuData[key]?.sortType !== null && storeHeaderMenuData[key]?.sortType !== undefined && storeHeaderMenuData[key]?.sortType !== "sort-unsort") {
      found = key;
      sortType = storeHeaderMenuData[key]?.sortType;
    }
  });

  if (found !== '' && storeHeaderMenuData) {
    switch (sortType) {
      case 'sort-asc':
        ngpReports.sort((a: NGPReport, b: NGPReport): number => (a[found] > b[found] ? 1 : -1));
        break;
      case 'sort-desc':
        ngpReports.sort((a: NGPReport, b: NGPReport): number => (a[found] < b[found] ? 1 : -1));
        break;
    }
  } else {
    ngpReports.sort((a: NGPReport, b: NGPReport): number => (a['diffGP'] > b['diffGP'] ? 1 : -1));

  }
  return ngpReports;
}

export function applyAdvancedFilterOnNGPReports(
  ngpReports: NGPReport[],
  appliedFilter: IAdvancedFilterGroup,
): NGPReport[] {
  if (appliedFilter?.filterGroup) {
    return applyAdvancedFilterGroupToData(ngpReports, appliedFilter);
  } else {
    return ngpReports;
  }
}
